class FooterLocalization extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".footer-localization__button");
    this.panel = this.querySelector(".footer-localization__panel");
    this.bindEvents();
    this.handleVisibility();
  }

  bindEvents() {
    if (this.button) {
      this.button.addEventListener("click", (e) => this.togglePanel(e));
    }
    document.addEventListener("click", (e) => this.handleClickOutside(e));
  }

  togglePanel(e) {
    const isExpanded = this.button.getAttribute("aria-expanded") === "true";
    this.button.setAttribute("aria-expanded", !isExpanded);
    this.panel.hidden = isExpanded;
  }

  handleClickOutside(e) {
    if (!this.contains(e.target)) {
      if (this.button) {
        this.button.setAttribute("aria-expanded", "false");
      }
      if (this.panel) {
        this.panel.hidden = true;
      }
    }
  }

  handleVisibility() {
    if (this.getAttribute("data-visibility") === "mobile") {
      const mediaQuery = window.matchMedia("(min-width: 769px)");
      const hideBlock = (e) => {
        const parentBlock = this.closest(".shopify-block");
        if (parentBlock) {
          parentBlock.style.display = mediaQuery.matches ? "none" : "";
        }
      };

      // Initial check
      hideBlock();

      // Listen for resize
      mediaQuery.addEventListener("change", hideBlock);
    }
  }
}

customElements.define("footer-localization", FooterLocalization);
